var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccessibility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 28,
    viewBox: "0 0 26 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 5.11C12.2778 5.11 11.6579 4.85917 11.1403 4.3575C10.6227 3.85583 10.3639 3.255 10.3639 2.555C10.3639 1.855 10.6227 1.25417 11.1403 0.7525C11.6579 0.250833 12.2778 0 13 0C13.7222 0 14.3421 0.250833 14.8597 0.7525C15.3773 1.25417 15.6361 1.855 15.6361 2.555C15.6361 3.255 15.3773 3.85583 14.8597 4.3575C14.3421 4.85917 13.7222 5.11 13 5.11ZM9.13611 28V9.345C7.49907 9.22833 5.9162 9.065 4.3875 8.855C2.8588 8.645 1.3963 8.37667 0 8.05L0.541667 5.95C2.58796 6.41667 4.62222 6.74917 6.64444 6.9475C8.66667 7.14583 10.7852 7.245 13 7.245C15.2148 7.245 17.3333 7.14583 19.3556 6.9475C21.3778 6.74917 23.412 6.41667 25.4583 5.95L26 8.05C24.6037 8.37667 23.1412 8.645 21.6125 8.855C20.0838 9.065 18.5009 9.22833 16.8639 9.345V28H14.6972V18.9H11.3028V28H9.13611Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessibility);
export default __webpack_public_path__ + "static/media/accessibility.d0a510e97579df4117c5a0900af74405.svg";
export { ForwardRef as ReactComponent };